<template>
	<v-expansion-panel>
		<v-expansion-panel-header expand-icon="" color="secondary">
			<v-toolbar rounded color="secondary" elevation="0" :outlined="false" dense class="pt-0 pb-0 mr-0 ml-0 font-weight-bold white--text justify-center text-center"
				><v-spacer></v-spacer><v-toolbar-title class="justify-center text-center" style="font-size: 32px">{{ title }}</v-toolbar-title
				><v-spacer></v-spacer
			></v-toolbar>
		</v-expansion-panel-header>
		<v-expansion-panel-content class="mx-auto justify-center text-center ml-5 mr-5 mt-5">
			<v-card-text class="justify-center text-center">
				<v-row class="justify-left text-center"> </v-row>
			</v-card-text>
		</v-expansion-panel-content>
	</v-expansion-panel>
</template>

<script>
export default {
	name: 'AdminViewPracticeBankingCard',
	components: {},
	props: {
		company: { type: Object, optional: false, required: true },
	},
	data: () => ({
		title: 'Banking Details',
		readonly: {
			secondaryemail: true,
			bussinessTel: true,
			managerEmail: true,
		},
	}),
	methods: {
		edit(key) {
			Object.keys(this.readonly)
				.filter(k => k != key && !this.readonly[k])
				.forEach(k => this.finished(k));
			this.readonly[key] = false;
			this.$forceUpdate();
		},
		finished(key) {
			this.readonly[key] = true;
			this.$forceUpdate();
		},
	},
};
</script>
